import { createSlice } from '@reduxjs/toolkit';

import eventBus, { EventType } from '@utils/eventBus';

import { handleEditUserEnteredSupplement, handleGetUserEnteredSupplementDetails } from './actions';
import { IUserEnteredSupplementDetailsState } from './slice.interface';

const initialState: IUserEnteredSupplementDetailsState = {
  data: null,
  isLoading: false,
  error: false,
};

export const userEnteredSupplementDetailsSlice = createSlice({
  name: 'user-entered-supplement-details',
  initialState,
  reducers: {
    removeUserEnteredSupplementDetails: state => {
      state.data = null;
      state.isLoading = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(
        handleGetUserEnteredSupplementDetails.pending,
        (state: IUserEnteredSupplementDetailsState) => {
          state.isLoading = true;
          state.error = false;
        },
      )
      .addCase(
        handleGetUserEnteredSupplementDetails.rejected,
        (state: IUserEnteredSupplementDetailsState) => {
          state.isLoading = false;
          state.error = true;
        },
      )
      .addCase(
        handleGetUserEnteredSupplementDetails.fulfilled,
        (state: IUserEnteredSupplementDetailsState, action) => {
          state.data = action.payload.data;
          state.isLoading = false;
        },
      )
      .addCase(handleEditUserEnteredSupplement.fulfilled, () => {
        eventBus.emit(EventType.EDIT_NEW_SUPPLEMENT_SUCCESS);
      });
  },
});

export const { removeUserEnteredSupplementDetails } = userEnteredSupplementDetailsSlice.actions;

export default userEnteredSupplementDetailsSlice.reducer;
